import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {STATO_ENUM_UI} from '../../../_helpers/StatoEnum';
import {StatoEnum} from "../../../_models/generated/stato-enum";
import {EnumUiMap} from "../../../_services/meta.service";

@Component({
    selector: 'app-tracciato-field-stato',
    templateUrl: './tracciato-field-stato.component.html',
    styleUrls: ['./tracciato-field-stato.component.scss'],
    standalone: false
})
export class TracciatoFieldStatoComponent implements OnInit {
  @Input() statoCode: string;
  @Output() statoCodeChange = new EventEmitter<string>();
  stati = StatoEnum;
  // Copia per-istanza: STATO_ENUM_UI è un singleton condiviso a livello di modulo. Scrivere i
  // newValue direttamente su di esso li faceva persistere da un campo all'altro (anche tra modali).
  statiDict: EnumUiMap = {};

  ngOnInit() {
    for (const key of Object.keys(STATO_ENUM_UI)) {
      this.statiDict[key] = {...STATO_ENUM_UI[key], newValue: ''};
    }

    if (this.statoCode == null) {
      return;
    }

    // Più valori macchina per lo stesso stato sono codificati come coppie ripetute (es. "6=2;6=4").
    // In UI li accorpiamo in un unico campo separato da "," (es. "2,4").
    this.statoCode.split(';').forEach((original: string) => {
      const value = original.split('=');
      if (value.length === 2 && this.statiDict[value[0]] != null && value[1] !== '') {
        const current = this.statiDict[value[0]].newValue;
        this.statiDict[value[0]].newValue = current ? `${current},${value[1]}` : value[1];
      }
    });
  }

  onChangeValue = () => {
    const keys = Object.keys(this.stati).filter(k => isNaN(Number(k)));
    this.statoCode = '';
    keys.forEach((key) => {
      const enumValue = this.stati[key];
      if (this.statiDict[enumValue] == null || !this.statiDict[enumValue].newValue) return;
      // Espande l'input "2,4" in coppie ripetute "6=2;6=4;" attese dal backend (match esatto del lato destro).
      this.statiDict[enumValue].newValue
        .split(',')
        .map((v: string) => v.trim())
        .filter((v: string) => v !== '')
        .forEach((v: string) => {
          this.statoCode += enumValue + '=' + v + ';';
        });
    });
    this.statoCodeChange.emit(this.statoCode);
  };
}
